import type { ItemType } from '~/types/delivery'
import { api } from '.'

export function getItemTypes(ids: number[]) {
  // Don't use URLSearchParams, it won't work on some iOS devices
  const query = ids.map((id) => `ids=${id}`).join('&')
  return api.service.get('delivery/item-types/by-ids' + '?' + query).json<{
    item_types: ItemType[]
  }>()
}
